export default function () {
	$('.sl-dropdown-toggle').on('click', event => {
		$(event.currentTarget).parent().find('.sl-dropdown-menu').toggle();
		$(event.currentTarget).toggleClass('sl-open');
	});

	$('.sl-dropdown-menu-mega .sl-dropdown-link').on('click', event => {
		event.preventDefault();
		const id = $(event.currentTarget).attr('href');

		$('.sl-dropdown-link').removeClass('sl-active');
		$('.sl-dropdown-menu-mega-content').removeClass('sl-active');

		$(id).addClass('sl-active');
		$(event.currentTarget).addClass('sl-active');
	});
}
